import * as React from 'react';
import PropTypes from 'prop-types';
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Tooltip from '@mui/material/Tooltip';
import { visuallyHidden } from '@mui/utils';
import { Button, capitalize, Chip, Collapse, Dialog, DialogActions, DialogContent, Divider, FormControl, Grid, IconButton, InputLabel, LinearProgress, List, ListItem, ListItemText, MenuItem, Select, Stack, Switch } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { deletePlatform, fetchPlatforms, toggleActivation } from '../../store/platformSlice';
import PlatformForm from '../platform/PlatformForm';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import CommentDrawer from '../Common/Drawer';
import { AVAILABLE_INTEGRATIONS, capitalizeWords, ROWS_PER_PAGE } from '../../utils/constant';
import { fetchIndustries, fetchIndustryList } from '../../store/industrySlice';
import Confirmation from '../Common/Confirmation';
import FilterListOffIcon from '@mui/icons-material/FilterListOff';
import { useTheme, useMediaQuery } from '@mui/material/styles';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import ContactMailOutlinedIcon from '@mui/icons-material/ContactMailOutlined';
import { useNavigate } from 'react-router-dom';
import BasicPopover from '../Common/PopOver';
import { NoData } from '../Common/NoData';
import { AccessTime, PlayCircleFilled, CheckCircle, Cancel, Stop, CloseRounded } from '@mui/icons-material';

function createData(id, name, keywords, industry, domain, status, active, actions, source) {
    return {
        id,
        name,
        keywords,
        industry,
        domain,
        status,
        active,
        actions,
        source
    };
}
const statusIcons = {
    queued: <AccessTime fontSize="small" className='mr-1' />,
    running: <PlayCircleFilled fontSize="small" className='mr-1' />,
    completed: <CheckCircle fontSize="small" className='mr-1' />,
    failed: <Cancel fontSize="small" className='mr-1' />,
    stopped: <Stop fontSize="small" className='mr-1' />,
};
const PlatformActions = ({ page, setPage, getPlatfroms, platformModal, setPlatformModal, platfrom, selectedPlatform, setSelectedPlatfrom, canDelete, canEdit }) => {
    const [isOpen, setIsOpen] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const userRole = useSelector((state) => state.userReducer.userRole)
    canEdit = process.env.REACT_APP_ADMIN_ROLE === userRole || canEdit;
    canDelete = process.env.REACT_APP_ADMIN_ROLE === userRole || canDelete;

    const handleDelete = async (id) => {
        try {
            dispatch(deletePlatform(id)).then(() => {
                // if(page){
                //     setPage(0)
                // }else{
                // }
                getPlatfroms()
            })
        } catch (error) {
            console.error(error);
        }
    }

    const handleScrappedLeads = (platform) => {
        navigate('/leads/scrapped', { state: { platform: platform.id } });
    };

    const handleContactLeads = (platform) => {
        navigate('/leads/hot-leads', { state: { domainId: platform?.domain?.id } });
    };

    return (
        <>
            <Grid spacing={4} justifyContent={'flex-end'}>
                {/* <PlatformForm title="Edit Platform"  {...{ platformModal, setPlatformModal, platformModal, selectedPlatform }} /> */}
                <Grid size={8}>
                    <CommentDrawer {...{ open, setOpen }} >
                        <Box className="p-3">
                            <Typography variant="h6" gutterBottom>
                                Platform Detail
                            </Typography>
                            <Divider />
                            <div className='role-form-scroller'>
                                <TableContainer component={Paper} className="mb-3 mt-3">
                                    <Table>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell>
                                                    <Typography className='table-detail-cells-head' variant='body2'>Platform:</Typography>
                                                </TableCell>
                                                <TableCell className='td-keyval'>
                                                    {platfrom.name}
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>
                                                    <Typography className='table-detail-cells-head' variant='body2'>Source:</Typography>
                                                </TableCell>
                                                <TableCell className='td-keyval'>
                                                    {platfrom.integration}
                                                </TableCell>
                                            </TableRow>
                                            {/* <TableRow>
                                                <TableCell>
                                                    <Typography className='table-detail-cells-head' variant='body2'>Domains:</Typography>
                                                </TableCell>
                                                <TableCell className='td-keyval'>

                                                    {platfrom?.domains?.map((domain, index) =>
                                                        <TypographyclassName='table-detail-cells-head' variant='body2' variant='body2'>{index + 1}. {domain?.domain?.route} - {domain?.max_count} </Typography>
                                                    )}

                                                </TableCell>
                                            </TableRow> */}
                                            <TableRow>
                                                <TableCell>
                                                    <Typography className='table-detail-cells-head' variant='body2'>Description:</Typography>
                                                </TableCell>
                                                <TableCell className='td-keyval'>
                                                    {platfrom.description}
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                {platfrom?.domains?.length ?
                                    <TableContainer component={Paper}>
                                        <Table aria-label="simple table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Domain</TableCell>
                                                    <TableCell align="left">Max</TableCell>
                                                    <TableCell align="left">Usage</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {platfrom?.domains?.map((row) => (
                                                    <TableRow
                                                        key={row.key}
                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                        <TableCell component="th" scope="row" sx={{ wordBreak: 'break-all', whiteSpace: 'normal' }}>
                                                            <a href={row?.domain?.route} target="_blank" rel="noopener noreferrer" >
                                                                <Typography color='primary' variant='body2' style={{ textDecoration: 'underline' }} > {row?.domain?.route} </Typography>
                                                            </a>
                                                        </TableCell>
                                                        <TableCell align="left">{row?.max_count}</TableCell>
                                                        <TableCell align="left">{row?.usage_count}</TableCell>

                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer> : <></>}
                                <TableContainer component={Paper} className='mt-3'>
                                    <Table aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Key</TableCell>
                                                <TableCell align="left">Value</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {platfrom?.settings?.map((row) => (
                                                <TableRow
                                                    key={row.key}
                                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                >
                                                    <TableCell component="th" scope="row" color='primary'>
                                                        {row.key}

                                                    </TableCell>
                                                    <TableCell sx={{ wordBreak: 'break-all', whiteSpace: 'normal' }} align="left">{row.value}</TableCell>

                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                        </Box>
                        <Box className="drawer-footer m-3">
                            <Button
                                type="button"
                                variant="outlined"
                                color="primary"
                                onClick={() => setOpen(false)}
                                className="mt-2 mr-2"
                            >
                                close
                            </Button>
                        </Box>
                    </CommentDrawer>
                    <Box gap={2} display='flex' alignItems={"center"} className="table-margin">
                        <RemoveRedEyeOutlinedIcon className='link-color' onClick={() => {
                            setOpen(true);
                        }} />
                        <EditOutlinedIcon className={`${!canEdit ? 'icon-disabled link-color' : 'link-color'}`} onClick={() => {

                            if (canEdit) { setSelectedPlatfrom(platfrom); setPlatformModal(true); }
                        }} />
                        <DeleteOutlineOutlinedIcon className={`${!canDelete ? 'icon-disabled danger-color' : 'danger-color'}`} onClick={() => {
                            if (canDelete)
                                setIsOpen(true)
                        }} />
                        <Tooltip title="Navigate to Scrapped leads to show up the leads for the selected platform
Improved: View scrapped leads for the selected platform" arrow>

                            <CorporateFareIcon className='navigate-action' color='primary' onClick={() => {
                                handleScrappedLeads(platfrom)
                            }} />
                        </Tooltip>

                        <Tooltip title="Navigate to Hot leads to show up the leads for the selected platform
Improved: View hot leads for the selected platform" arrow>

                            <ContactMailOutlinedIcon color='primary' className='navigate-action' onClick={() => {
                                handleContactLeads(platfrom)
                            }} />
                        </Tooltip>

                    </Box>
                    <>
                        <Confirmation open={isOpen} setOpen={setIsOpen} msg={"Are you sure you want to delete this Platform"} yesClick={() => { handleDelete(platfrom.uuid); setIsOpen(false) }} />
                    </>
                </Grid>
            </Grid>
        </>
    )
}

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

const headCells = [
    {
        label: 'Platform',
        numeric: false,
        disablePadding: false,
        id: 'name',
        sortable: true
    },
    {
        label: 'Industry',
        numeric: false,
        disablePadding: false,
        id: 'industry__title',
        sortable: true
    },
    {
        label: 'Source',
        numeric: false,
        disablePadding: false,
        id: 'integration',
        sortable: true
    },
    {
        label: 'Search Keywords',
        numeric: false,
        disablePadding: false,
        id: 'searchKeywords',
        sortable: false
    },
    {
        label: 'Status',
        numeric: false,
        disablePadding: false,
        id: 'status',
        sortable: true
    },
    {
        label: 'Active',
        numeric: false,
        disablePadding: false,
        id: 'active',
        sortable: false
    },
    {
        label: 'Actions',
        numeric: false,
        disablePadding: false,
        id: 'actions',
        sortable: false
    },
];

function EnhancedTableHead(props) {
    const { setOrdering, orderingState, setOrderingState } =
        props;

    const createSortHandler = (property) => (event) => {
        const orderData = orderingState
        const exists = orderData?.find((item) => item.id === property);
        const updated = (() => {

            if (exists) {
                return orderData.map((item) =>
                    item.id === property
                        ? { ...item, order: item.order === "asc" ? "desc" : "asc" }
                        : item
                );
            } else {
                return [...orderData, { id: property, order: "asc" }];
            }
        })();
        setOrderingState(updated)

    };

    React.useEffect(() => {
        const ordering = orderingState.map((item) => {
            return item.order === "asc" ? item.id : "-" + item.id;
        });
        if (ordering?.length) {
            setOrdering(ordering.join(","));
        }

    }, [orderingState]);

    const removeFilter = (property) => {
        const data = orderingState.filter((item) => item.id !== property)
        setOrderingState(data)
    }
    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) => {
                    const key = headCell.id;
                    const sortObj = orderingState.find((item) => item.id === key);
                    const isSorted = !!sortObj;
                    const sortDirection = sortObj?.order || "asc";

                    return (<TableCell
                        className="font-weight"
                        key={key}
                        align={headCell.numeric ? "left" : "left"}
                        padding={headCell.disablePadding ? "none" : "normal"}
                        sortDirection={isSorted ? sortDirection : false}
                    >
                        {headCell.sortable ? <TableSortLabel
                            active={isSorted}
                            direction={sortDirection}
                            onClick={createSortHandler(key)}
                            color="secondary"
                            hideSortIcon={false}
                        >
                            {headCell.label}
                            {isSorted && (
                                <Box component="span" sx={visuallyHidden}>
                                    {sortDirection === "desc" ? "sorted descending" : "sorted ascending"}
                                </Box>
                            )}
                            {isSorted && <FilterListOffIcon onClick={(e) => { e.stopPropagation(); removeFilter(headCell.id) }} className="ml-2" size="small" color='primary' />}
                        </TableSortLabel> : headCell.label}
                    </TableCell>)
                })}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};
function EnhancedTableToolbar(props) {
    const { page, setPage, getPlatfroms, platformModal, setPlatformModal, setSelectedPlatfrom, selectedPlatform, setResetTrigger, resetTrigger, currentIntegration, setCurrentIntegration } = props;
    return (
        <>
            <PlatformForm {...{ page, setPage, getPlatfroms, platformModal, setPlatformModal, setSelectedPlatfrom, selectedPlatform, resetTrigger }} title={selectedPlatform ? "Edit" : "Create"} />
            <Toolbar className="main-list-toolbar">
                <Grid container alignItems="center" spacing={1} sx={{ mb: { xs: 1,  } }}>
                    <Grid item xs={12} sm={4} md={6} lg={8.8}>
                        <Typography
                            className="d-flex"
                            variant="h6"
                            id="tableTitle"
                            component="div"
                        >
                            Platforms
                        </Typography>
                    </Grid>
                    <Grid item xs={5.5} sm={4} md={3} lg={1.7}>
                        <FormControl size="small" fullWidth>
                            <InputLabel id="integration">Integration</InputLabel>
                            <Select
                                labelId="integration"
                                id="integration"
                                name="integration"
                                label="Integration"
                                value={currentIntegration}
                                onChange={(e) => setCurrentIntegration(e.target.value)}
                                endAdornment={
                                    currentIntegration ? (
                                        <IconButton
                                            size="small"
                                            onClick={() => setCurrentIntegration(0)}
                                            onMouseDown={(event) => event.stopPropagation()}
                                        >
                                            <CloseRounded className='mr-2' />
                                        </IconButton>
                                    ) : null
                                }
                                MenuProps={{
                                    PaperProps: {
                                        className: "mui-select-menu",
                                    },
                                }}
                            >
                                <MenuItem value={0}>All</MenuItem>
                                {AVAILABLE_INTEGRATIONS?.map((ele) => (
                                    <MenuItem key={ele?.name} value={ele?.name}>
                                        {ele?.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={6.5} sm={4} md={3} lg={1.5}>
                        <Tooltip title="Create">
                            <Button
                                variant="contained"
                                fullWidth
                                onClick={() => {
                                    setResetTrigger(!resetTrigger);
                                    setSelectedPlatfrom(null);
                                    setPlatformModal(true);
                                }}
                            >
                                Create Platform
                            </Button>
                        </Tooltip>
                    </Grid>
                </Grid>
            </Toolbar>
        </>
    );
}

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};

export default function PlatformManage() {
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('calories');
    const [selected, setSelected] = React.useState([]);
    const [rows, setRows] = React.useState([]);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(ROWS_PER_PAGE);
    const [platformModal, setPlatformModal] = React.useState(false);
    const [selectedPlatform, setSelectedPlatfrom] = React.useState({});
    const [resetTrigger, setResetTrigger] = React.useState(false);
    const [queryString, setQueryString] = React.useState("");
    const [currentIntegration, setCurrentIntegration] = React.useState(0);
    const [opneActiveConfirm, setOpneActiveConfirm] = React.useState(false);
    const userPermission = useSelector((state) => state.userReducer.userPermission)
    const platformPermissions = userPermission.find((perm) => perm.model_name === "platform")?.permissions || [];
    let canEdit = platformPermissions.includes("change");
    let canDelete = platformPermissions.includes("delete");
    const [ordering, setOrdering] = React.useState();
    const [orderingState, setOrderingState] = React.useState([])
    const platforms = useSelector((state) => state.platformReducer.platforms)
    const loading = useSelector((state) => state.platformReducer.loading)
    const count = useSelector((state) => state.platformReducer.count)
    const dispatch = useDispatch()

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelected = rows.map((n) => n.id);
            setSelected(newSelected);
            return;
        }
        setSelected([]);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const label = { inputProps: { 'aria-label': 'Color switch demo' } };

    React.useEffect(() => {

        const rowData = platforms?.map((ele) => {
            const searchSetting = ele?.settings?.find(setting => setting.key === "SEARCH_KEYWORD");
            const source = ele?.integration || 'N/A';
            return createData(
                ele.id,
                ele.name,
                searchSetting?.value,
                ele?.industry?.title,
                ele.domain?.route,
                { status: ele.status, taskResult: ele.task_results },
                <Switch disabled={loading} className={`${!canEdit && 'icon-disabled'}`} checked={ele.deactivated_on ? false : true} {...label} onClick={(e) => {
                    if (canEdit) {
                        setSelectedPlatfrom(ele)
                        if (!ele?.deactivated_on) {
                            setOpneActiveConfirm(true)
                        } else {
                            dispatch(toggleActivation(ele.uuid))
                        }
                    }
                }} />,
                <PlatformActions {...{ page, setPage, getPlatfroms, canDelete, canEdit, platformModal, setPlatformModal, selectedPlatform, setSelectedPlatfrom }} platfrom={ele} />,
                source
            )
        })
        setRows(rowData)
    }, [platforms, loading])

    React.useEffect(() => {
        dispatch(fetchIndustryList())
    }, [])

    const getPlatfroms = () => {
        dispatch(fetchPlatforms({ queryString }));
    }

    React.useEffect(() => {
        setQueryString(`?page=${page + 1}&page_size=${rowsPerPage}&ordering=${ordering ? ordering : "updated_at"}&integration=${currentIntegration ? currentIntegration : ""}`)
    }, [ordering, page, rowsPerPage, currentIntegration])

    React.useEffect(() => {
        if (queryString) {
            getPlatfroms()
            const interval = setInterval(() => {
                getPlatfroms()
            }, 180000);
            return () => clearInterval(interval);
        }
    }, [queryString, dispatch])

    function Row(props) {
        const theme = useTheme();
        const { row, labelId } = props;
        return (
            <React.Fragment>
                <TableRow
                    hover
                    role="checkbox"
                    tabIndex={-1}
                    key={row.id}
                    id={labelId}
                    className='cursor-pointer'
                >
                    <TableCell align="left">{capitalizeWords(row.name || "N/A")}</TableCell>
                    <TableCell align="left">{row.industry || "N/A"}</TableCell>
                    <TableCell align="left">{row.source || 'N/A'}</TableCell>
                    <TableCell align="left">
                        <Stack spacing={1}>
                            <Stack direction="row" spacing={1}>
                                {row?.keywords ? (
                                    <Typography color='primary' variant='body2'>{row.keywords?.split(",")[0]?.trim()}</Typography>
                                ) : (
                                    <>N/A</>
                                )}
                                {row?.keywords?.split(",").length > 1 && (
                                    <BasicPopover length={row?.keywords.split(",").length - 1}>
                                        <List disablePadding dense className='location-list'>
                                            {row?.keywords.split(",").slice(1).map((ele, index) => (
                                                <ListItem key={index} disableGutters>
                                                    <ListItemText
                                                        primary={
                                                            <Typography color='primary' variant='body2'>{index + 1}. {ele}</Typography>
                                                        }
                                                    />
                                                </ListItem>
                                            ))}
                                        </List>
                                    </BasicPopover>
                                )}
                            </Stack>
                        </Stack>

                    </TableCell>
                    <TableCell align="left">
                        <BasicPopover
                            customTrigger={
                                <Button
                                    size="small"
                                    sx={{
                                        color: theme.palette.custom[row?.status?.status],
                                        backgroundColor: alpha(theme.palette.custom[row?.status?.status + 'Background'], 0.1),
                                        borderColor: theme.palette.custom[row?.status?.status + 'Border'],
                                        textTransform: 'capitalize',
                                        '&:hover': {
                                            backgroundColor: alpha(theme.palette.custom[row?.status?.status + 'Background'], 0.2),
                                            borderColor: theme.palette.custom[row?.status?.status + 'Border'],
                                        },
                                    }}
                                    variant="outlined"
                                >
                                    {/* {statusIcons[row?.status?.status]} */}
                                    {row?.status?.status}
                                </Button>
                            }
                        >

                            {Array.isArray(row?.status?.taskResult) && row.status.taskResult.length > 0 && (
                                <List disablePadding dense className="location-list">
                                    {row.status.taskResult.map((loc, index) => (
                                        <ListItem key={index} disableGutters>
                                        
                                                <Box className="d-flex">
                                                    <Typography
                                                        color="primary"
                                                        variant="body2"
                                                        sx={{ textTransform: 'capitalize', whiteSpace: 'wrap' }}
                                                    >
                                                        {index + 1}. {loc?.feed_type?.replace(/_/g, ' ')} Status:
                                                    </Typography>
                                                    <Typography
                                                        variant="body2"
                                                        className='ml-2'
                                                        sx={{
                                                            color: theme.palette.custom[loc?.custom_status],
                                                            textTransform: 'capitalize',
                                                            whiteSpace: 'nowrap',
                                                        }}
                                                    >
                                                        {loc?.custom_status}
                                                    </Typography>
                                                </Box>

                                                {/* <Grid item xs={1}>
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            alignItems: 'center',
                                                            color: theme.palette.custom[loc?.custom_status],
                                                        }}
                                                    >
                                                        {statusIcons[loc?.custom_status]}
                                                    </Box>
                                                </Grid> */}

                                                
                                        </ListItem>
                                    ))}
                                </List>
                            )}

                        </BasicPopover>
                    </TableCell>
                    <TableCell align="left">{row.active}</TableCell>
                    <TableCell align="left">{row.actions}</TableCell>
                </TableRow>

            </React.Fragment >
        );
    }

    return (
        <Box className='w-100'>
            <Confirmation {...{ open: opneActiveConfirm, setOpen: setOpneActiveConfirm, msg: "Are you sure you want to Inactive this Platform", yesClick: () => { dispatch(toggleActivation(selectedPlatform.uuid)); setOpneActiveConfirm(false) } }} />
            <Paper className="w-100 mb-2" >
                <EnhancedTableToolbar numSelected={selected.length} {...{ currentIntegration, setCurrentIntegration, page, setPage, getPlatfroms, platformModal, setPlatformModal, platformModal, selectedPlatform, setSelectedPlatfrom, setResetTrigger, resetTrigger }} />
                {loading && <LinearProgress />}
                <TableContainer className='position-relative'>
                    <Table
                        className='min-width-750'
                        aria-labelledby="tableTitle"
                        size={'small'}
                    >
                        <EnhancedTableHead
                            numSelected={selected.length}
                            orderingState={orderingState}
                            setOrderingState={setOrderingState}
                            setOrdering={setOrdering}
                            onSelectAllClick={handleSelectAllClick}
                            onRequestSort={handleRequestSort}
                            rowCount={rows?.length}
                        />
                        <TableBody>
                            {rows?.map((row, index) => {
                                const labelId = `enhanced-table-checkbox-${index}`;
                                return (
                                    <Row row={row} label={labelId} />
                                );
                            })}
                        </TableBody>
                    </Table>
                    {!platforms?.length && !loading && <NoData></NoData>}
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={count}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>

        </Box>
    );
}
